import React, { useEffect } from 'react';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { Icon, Select, Tooltip } from 'antd';
import { fieldNames } from '../../../config';
import useCompanies from '../../../../../../../../queries/useCompanies';
import {
  shutdownEmitter,
  shutdownEvtNames,
} from '../../../../../../shared/constants';

const { Option } = Select;
const fieldName = fieldNames.company;

const getCompanyValue = (value, data) => {
  if (value === undefined || value === null) return value;
  const item = data.find((i) => i.id === value);
  return item ? value : undefined;
};

const newCompanyValueEmit = (value) =>
  shutdownEmitter.emit(shutdownEvtNames.newCompanyValue, value);

const CompanyField = ({ form }) => {
  const { data: companies = [], isFetching } = useCompanies({
    staleTime: Infinity,
  });

  useEffect(() => {
    if (companies?.length) {
      const evtName = shutdownEvtNames.setDraftCompanyValue;

      const handler = (values) => {
        const company = getCompanyValue(values[fieldName], companies);

        form.setFieldsValue({ [fieldName]: company });
        const newValues = { ...values, [fieldName]: company };
        newCompanyValueEmit(newValues);
      };

      shutdownEmitter.on(evtName, handler);

      return () => shutdownEmitter.off(evtName, handler);
    }
  }, [companies]);

  return (
    <Field
      fieldType={fieldTypes.select}
      // hidden={hidden}
      form={form}
      name={fieldName}
      label={
        <span>
          Компания&nbsp;
          <Tooltip title="На основе компании формируются список городов и адреса">
            <Icon
              type="info-circle"
              style={{ fontSize: '16px' }}
            />
          </Tooltip>
        </span>
      }
      decoratorOptions={{
        rules: [
          {
            required: true,
            message: 'Укажите УК',
          },
        ],
      }}
      fieldProps={{
        placeholder: 'Выберите УК',
        loading: isFetching,
        disabled: isFetching,
        showSearch: true,
        optionFilterProp: 'searchtext',
        onChange: (value) => newCompanyValueEmit({ [fieldName]: value }),
      }}
      items={companies}
      renderOption={(item) => (
        <Option
          key={item.id}
          value={item.id}
          searchtext={item.name}
        >
          {item.name}
        </Option>
      )}
    />
  );
};

export default CompanyField;
